var _path, _g, _g2, _g3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMotel = function SvgMotel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 25.5
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 329",
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M1 24.5h27"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8902",
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 2390",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M4.441 0h18v25h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.441 1h16v23h-16z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 330",
    d: "M9.941 21.5h7"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 2391",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M10.441 15h6v7h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.441 16h4v5h-4z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8917",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8915"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 339",
    d: "M8.941 7.5v-3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 340",
    d: "M11.191 4.5h-2.25"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8916"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 339",
    d: "M16.316 7.5v-3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 340",
    d: "M18.566 4.5h-2.25"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8918",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8915"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 339",
    d: "M8.941 13.5v-3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 340",
    d: "M11.191 10.5h-2.25"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8916"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 339",
    d: "M16.316 13.5v-3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 340",
    d: "M18.566 10.5h-2.25"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8903"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 2390",
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M20.941 5H28v20h-7.059z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.941 6H27v18h-5.059z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8904"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 2390",
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M1 8.806h5.059V25H1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 9.806h3.059V24H2z"
  })))));
};

export default SvgMotel;